import axios from 'axios';
import * as qs from 'qs';

export type UserNotification = {
  id: number;
  notificationId: number;
  title: string;
  body: string;
  type: string;
  data?: Record<string, string> | null;
  isRead: boolean;
  readAt?: string | null;
  createdAt: string;
};

export const getNotifications = async (params: { page?: number; size?: number }) => {
  const query = qs.stringify({ ...params }, { skipNulls: true });
  const { data } = await axios.get(`/notifications?${query}`);
  return data as { success: boolean; total: number; notifications: UserNotification[] };
};

export const getRecentNotifications = async (limit = 15) => {
  const { data } = await axios.get(`/notifications/recent?limit=${limit}`);
  return data as { success: boolean; notifications: UserNotification[] };
};

export const getUnreadNotificationCount = async () => {
  const { data } = await axios.get('/notifications/unread-count');
  return data as { success: boolean; unreadCount: number };
};

export const markNotificationRead = async (id: number) => {
  const { data } = await axios.put(`/notifications/${id}/read`);
  return data as { success: boolean };
};

export const markAllNotificationsRead = async () => {
  const { data } = await axios.put('/notifications/read-all');
  return data as { success: boolean };
};
